import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import { documentAllowedRepo, documentAllowed, ApiEndpoint, name, platform, hideRegion } from "../Constant";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import Form from "../Components/form";
import { Input, Textarea, Select, File } from "../Components/input";
import { RedirectNotLogin, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray, clearSession, RedirectNotContractor } from "../Components/function";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import * as axios from 'axios';
import $ from 'jquery';


// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}

const StatusXD = [
    {value: '0', text: 'Pending'},
    {value: '1', text: 'Published'}
]


class Editdetails extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      data: '',
      publishing_status: '',
      publication_date: '',
      volume: '',
      pages_number: '',
      issue_number: '',
      issn: '',
      note: '',
      message: '',
      loading: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectNotContractor();
      this.loadDataFromServer();

      $(function(){
      $('.input-date').on('focus', function(){
       $(this).attr('type', 'date');
      });

      $('.input-date').on('focusout', function(){
      $(this).attr('type', 'text');
      });

      });
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectNotContractor();
    }

    loadDataFromServer = async () => {
        
      UpdateState(this, 'loading', '1');

      let DeviceSid = await FingerPrint();

      let header = {
          headers : {
              'Accept': 'application/json',
              'Content-Type': "application/x-www-form-urlencoded",
              'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
              'My-Custom-Header': name,
              'User-Agent': name+ " Bot",
             }
       };

       let datas = new URLSearchParams({
          command: 'fetch',
          cmd: 'fetchdetails',
          user_id: getSession('userID'),
          scriptID: this.props?.match?.params?.id,
      }).toString();
       
         axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
         .then(response => {
         
          UpdateState(this, 'loading', '0');


          if(response?.data?.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
             setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
           }

    
        if(response?.data?.error == false && response?.data?.error != true){
        //alert(JSON.stringify(response?.data?.data));
        UpdateState(this, 'data', response?.data?.data != "" ? response?.data?.data : "");

        UpdateState(this, 'publishing_status', response?.data?.data?.publishing_status);
        UpdateState(this, 'publication_date', response?.data?.data?.publication_date);
        UpdateState(this, 'volume', response?.data?.data?.volume);
        UpdateState(this, 'pages_number', response?.data?.data?.pages_number);
        UpdateState(this, 'issue_number', response?.data?.data?.issue_number);
        UpdateState(this, 'issn', response?.data?.data?.issn);
        UpdateState(this, 'note', response?.data?.data?.note);
        UpdateState(this, 'scriptID', response?.data?.data?.scriptID);

        UpdateState(this, 'message', '');
        UpdateState(this, 'loading', '0');

        //alert(response?.data?.data);

        }
        else if(response?.data?.error != false){
          AlertMessage(this, response?.data?.error, 'error');

          if(response.data.logout == true && response?.data?.token == false){
            setTimeout(function(){
            clearSession();
            window.location.href = "/login";
            }, 4000);
            }
        }
        else{
          AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
        }
      }).catch(err => {
          AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
          this.loadDataFromServer();
      });
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
   

  
  <div className="card-lt-wrap">
    <div className="card-lt">
      
      <div className="info">Add/Edit Details of Downloaded Script for ScriptID: <b>{getState(this, 'scriptID')}</b></div>
    <div className="card-form-lt">
        <div className="title-lt">Add/Edit Details</div>
     
     <Form route="submit">
     
     {AlertMessageOut(this)}

     <label style={{textAlign: 'left', background: '#000', color: '#fff', width: '100%', display: 'block', padding: '8px'}}>
        Publishing Status and Date</label>

      <Select 
      wrapperClass="form-group-lt"
      inputClass="input-lt"
      inputState="publishing_status"
      inputPlaceholder="-- Select Publising Status --"
      inputOptions={StatusXD}
      inputRequired="required"
      inputSelected={getState(this, 'publishing_status')}
      self={this} />
      
      <Input 
      wrapperClass="form-group-lt"
      inputType="text"
      inputClass="input-lt input-date"
      inputState="publication_date"
      inputPlaceholder="Publication Date"
      inputMaxLength="125"
      inputValue={getState(this, 'publication_date')}
      self={this} />
      
      <label style={{textAlign: 'left', background: '#000', color: '#fff', width: '100%', display: 'block', padding: '8px'}}>
        Other Details</label>

      <Input 
      wrapperClass="form-group-lt"
      inputType="number"
      inputClass="input-lt"
      inputState="volume"
      inputPlaceholder="Volume/Numbers"
      inputMaxLength="10"
      inputValue={getState(this, 'volume')}
      self={this} />

      <Input 
      wrapperClass="form-group-lt"
      inputType="number"
      inputClass="input-lt"
      inputState="pages_number"
      inputPlaceholder="Pages Number"
      inputMaxLength="10"
      inputValue={getState(this, 'pages_number')}
      self={this} />

      <Input 
      wrapperClass="form-group-lt"
      inputType="text"
      inputClass="input-lt"
      inputState="issue_number"
      inputPlaceholder="Issue Number"
      inputMaxLength="50"
      inputValue={getState(this, 'issue_number')}
      self={this} />

      <Input 
      wrapperClass="form-group-lt"
      inputType="text"
      inputClass="input-lt"
      inputState="issn"
      inputPlaceholder="ISSN"
      inputMaxLength="60"
      inputValue={getState(this, 'issn')}
      self={this} />

      <Textarea 
      wrapperClass="form-group-lt"
      inputClass="input-lt"
      inputState="note"
      inputPlaceholder="Note (If Any)"
      inputRows="5"
      inputCols="30"
      inputMaxLength="280"
      inputValue={getState(this, 'note')}
      self={this} />

      <Button 
       wrapperClass="form-group-lt" 
       buttonClass="button-lt" 
       buttonText="SUBMIT"
       buttonAction="edit_details"
       self={this} />
       
       </Form>
      </div>
          
        </div>
        

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Editdetails;